import { PreactionSystemTypeEnum } from '@authority-labs/enums';
import { InspectionCase } from './inspection-case.dto';

export class InspectionPreactionSystemCaseDto extends InspectionCase {
  type?: PreactionSystemTypeEnum;
}

export class InspectionPreactionSystemCase extends InspectionPreactionSystemCaseDto {
  constructor(data: InspectionPreactionSystemCaseDto = {}) {
    super(data);
    this.type = data.type;
  }
}
